<template>
    <svg
        width="943"
        height="638"
        viewBox="0 0 943 638"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_480_13732)">
            <path
                d="M12 0.5H931C937.351 0.5 942.5 5.64872 942.5 12V626C942.5 632.351 937.351 637.5 931 637.5H12C5.64872 637.5 0.5 632.351 0.5 626V12C0.5 5.64873 5.64873 0.5 12 0.5Z"
                fill="var(--et-colors-background)"
                stroke="#D0D5DD"
            />
            <text
                fill="var(--et-colors-text)"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="24"
                font-weight="600"
                letter-spacing="0em"
            >
                <tspan x="36" y="60.8">Lesson name</tspan>
            </text>
            <path
                d="M36 96C36 89.3726 41.3726 84 48 84H563C569.627 84 575 89.3726 575 96V410C575 416.627 569.627 422 563 422H48C41.3726 422 36 416.627 36 410V96Z"
                fill="black"
            />
            <path
                d="M52 386C52 374.954 60.9543 366 72 366H539C550.046 366 559 374.954 559 386C559 397.046 550.046 406 539 406H72C60.9543 406 52 397.046 52 386Z"
                fill="#F2F4F7"
            />
            <path
                d="M72.5625 391.209C72.566 391.412 72.6253 391.611 72.7338 391.783C72.8423 391.956 72.996 392.095 73.1782 392.186C73.3601 392.289 73.5654 392.343 73.7743 392.343C73.9832 392.343 74.1886 392.289 74.3704 392.186L82.8238 386.958C83.0078 386.869 83.1629 386.73 83.2715 386.557C83.3801 386.385 83.4377 386.185 83.4377 385.98C83.4377 385.776 83.3801 385.576 83.2715 385.403C83.1629 385.23 83.0078 385.092 82.8238 385.003L74.3704 379.814C74.1886 379.711 73.9832 379.657 73.7743 379.657C73.5654 379.657 73.3601 379.711 73.1782 379.814C72.996 379.905 72.8423 380.044 72.7338 380.216C72.6253 380.389 72.566 380.588 72.5625 380.791V391.209Z"
                stroke="#475467"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <text
                fill="#344054"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="14"
                letter-spacing="0em"
            >
                <tspan x="99" y="390.9">0:00 / 0:00</tspan>
            </text>
            <path
                d="M191 386C191 383.791 192.791 382 195 382H467C469.209 382 471 383.791 471 386C471 388.209 469.209 390 467 390H195C192.791 390 191 388.209 191 386Z"
                fill="#EAECF0"
            />
            <path
                d="M191 386C191 383.791 192.791 382 195 382H299.7C301.909 382 303.7 383.791 303.7 386C303.7 388.209 301.909 390 299.7 390H195C192.791 390 191 388.209 191 386Z"
                fill="#101828"
            />
            <path
                d="M496.435 384.887C496.745 385.169 496.964 385.604 496.964 386.164C496.964 386.724 496.745 387.159 496.435 387.441M497.981 382.295C498.935 383.141 499.608 384.457 499.608 386.164C499.608 387.87 498.935 389.187 497.98 390.033M486.548 384.533C486.45 385.071 486.398 385.617 486.393 386.164C486.393 386.714 486.459 387.283 486.548 387.795C486.719 388.778 487.461 389.599 488.451 389.74C488.694 389.774 488.979 389.804 489.315 389.826C489.709 389.855 490.091 389.976 490.43 390.18C490.769 390.384 491.055 390.664 491.266 390.999C491.435 391.264 491.613 391.523 491.797 391.768C492.625 392.868 493.916 392.233 493.972 390.857C494.019 389.707 494.057 388.162 494.057 386.164C494.057 384.166 494.019 382.62 493.972 381.471C493.916 380.096 492.625 379.46 491.797 380.561C491.613 380.806 491.434 381.064 491.266 381.33C491.056 381.665 490.769 381.945 490.43 382.149C490.091 382.353 489.709 382.474 489.315 382.503C488.979 382.524 488.694 382.555 488.45 382.59C487.461 382.73 486.719 383.55 486.548 384.534V384.533Z"
                stroke="#475467"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M533 386.667C533.368 386.667 533.666 386.368 533.666 386C533.666 385.632 533.368 385.333 533 385.333C532.631 385.333 532.333 385.632 532.333 386C532.333 386.368 532.631 386.667 533 386.667Z"
                stroke="#475467"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M533 382C533.368 382 533.666 381.701 533.666 381.333C533.666 380.965 533.368 380.667 533 380.667C532.631 380.667 532.333 380.965 532.333 381.333C532.333 381.701 532.631 382 533 382Z"
                stroke="#475467"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M533 391.333C533.368 391.333 533.666 391.035 533.666 390.667C533.666 390.298 533.368 390 533 390C532.631 390 532.333 390.298 532.333 390.667C532.333 391.035 532.631 391.333 533 391.333Z"
                stroke="#475467"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M36 450C36 443.373 41.3726 438 48 438H563C569.627 438 575 443.373 575 450V494C575 500.627 569.627 506 563 506H48C41.3726 506 36 500.627 36 494V450Z"
                fill="var(--et-colors-background)"
                stroke="var(--et-colors-border)"
            />
            <g filter="url(#filter0_d_480_13732)">
                <path
                    d="M48.5 458C48.5 453.858 51.8579 450.5 56 450.5H220C224.142 450.5 227.5 453.858 227.5 458V486C227.5 490.142 224.142 493.5 220 493.5H56C51.8579 493.5 48.5 490.142 48.5 486V458Z"
                    fill="none"
                    stroke="var(--et-colors-border)"
                />
                <path
                    d="M70 481.25C64.8914 481.25 60.75 477.109 60.75 472C60.75 466.891 64.8914 462.75 70 462.75C75.1086 462.75 79.25 466.891 79.25 472C79.25 477.109 75.1086 481.25 70 481.25Z"
                    stroke="#D0D5DD"
                    stroke-width="1.5"
                />
                <text
                    fill="var(--et-colors-text)"
                    xml:space="preserve"
                    style="white-space: pre"
                    font-family="Geist"
                    font-size="14"
                    font-weight="500"
                    letter-spacing="0em"
                >
                    <tspan x="86" y="477.8">Mark as completed</tspan>
                </text>
            </g>
            <g filter="url(#filter1_d_480_13732)">
                <path
                    d="M426.5 460C426.5 455.858 429.858 452.5 434 452.5H555C559.142 452.5 562.5 455.858 562.5 460V484C562.5 488.142 559.142 491.5 555 491.5H434C429.858 491.5 426.5 488.142 426.5 484V460Z"
                    fill="none"
                    stroke="var(--et-colors-border)"
                />
                <text
                    fill="var(--et-colors-text)"
                    xml:space="preserve"
                    style="white-space: pre"
                    font-family="Geist"
                    font-size="14"
                    font-weight="500"
                    letter-spacing="0em"
                >
                    <tspan x="442" y="477.8">Next Lesson</tspan>
                </text>
                <path
                    d="M534.75 472H545.25M545.25 472L540 466.75M545.25 472L540 477.25"
                    stroke="#344054"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <text
                fill="var(--et-colors-text)"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="16"
                font-weight="500"
                letter-spacing="0em"
            >
                <tspan x="36" y="545.2">Description</tspan>
            </text>
            <path
                d="M599 48C599 41.3726 604.373 36 611 36H895C901.627 36 907 41.3726 907 48V110C907 116.627 901.627 122 895 122H611C604.373 122 599 116.627 599 110V48Z"
                fill="none"
                stroke="var(--et-colors-border)"
            />
            <text
                fill="var(--et-colors-text)"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="16"
                font-weight="500"
                letter-spacing="0em"
            >
                <tspan x="623" y="73.2">Course status</tspan>
            </text>
            <text
                fill="var(--et-colors-text)"
                xml:space="preserve"
                style="white-space: pre; opacity: 0.8"
                font-family="Geist"
                font-size="16"
                letter-spacing="0em"
            >
                <tspan x="851" y="73.2">58%</tspan>
            </text>
            <path
                d="M623 100C623 97.7909 624.791 96 627 96H879C881.209 96 883 97.7909 883 100C883 102.209 881.209 104 879 104H627C624.791 104 623 102.209 623 100Z"
                fill="var(--et-colors-border)"
            />
            <path
                d="M623 100C623 97.7909 624.791 96 627 96H790.925C793.134 96 794.925 97.7909 794.925 100C794.925 102.209 793.134 104 790.925 104H627C624.791 104 623 102.209 623 100Z"
                fill="var(--et-colors-brand)"
            />
            <path
                d="M599 146C599 139.373 604.373 134 611 134H895C901.627 134 907 139.373 907 146V458C907 464.627 901.627 470 895 470H611C604.373 470 599 464.627 599 458V146Z"
                fill="none"
                stroke="var(--et-colors-border)"
            />
            <text
                fill="var(--et-colors-text)"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="16"
                font-weight="500"
                letter-spacing="0em"
            >
                <tspan x="623" y="171.2">Content</tspan>
            </text>
            <text
                fill="var(--et-colors-text)"
                xml:space="preserve"
                style="white-space: pre; opacity: 0.8"
                font-family="Geist"
                font-size="16"
                letter-spacing="0em"
            >
                <tspan x="850" y="171.2">0/3</tspan>
            </text>
            <path
                d="M611.5 202C611.5 197.858 614.858 194.5 619 194.5H887C891.142 194.5 894.5 197.858 894.5 202V346C894.5 350.142 891.142 353.5 887 353.5H619C614.858 353.5 611.5 350.142 611.5 346V202Z"
                fill="none"
                stroke="var(--et-colors-border)"
            />
            <path
                d="M638 218.5L633 213.5L628 218.5"
                stroke="#98A2B3"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <text
                fill="var(--et-colors-text)"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="14"
                font-weight="500"
                letter-spacing="0em"
            >
                <tspan x="651" y="220.9">Chapter 1</tspan>
            </text>
            <path
                d="M634.767 248.411C638.599 249.015 640.721 251.682 640.721 256C640.721 260.942 637.942 263.721 633 263.721C630.071 263.721 627.902 262.745 626.621 260.921M625.279 256C625.272 256.842 625.365 257.681 625.557 258.501M626.799 250.841C626.241 251.572 625.836 252.407 625.607 253.298M631.673 248.351C630.784 248.442 629.915 248.673 629.099 249.037M636.482 255.314C635.363 254.062 633.761 253.227 632.05 252.683C631.886 252.631 631.714 252.616 631.544 252.638C631.374 252.66 631.211 252.72 631.067 252.812C630.922 252.905 630.8 253.028 630.709 253.173C630.618 253.318 630.56 253.481 630.539 253.651C630.329 255.211 630.329 256.791 630.539 258.35C630.56 258.52 630.618 258.683 630.709 258.828C630.801 258.973 630.923 259.096 631.067 259.188C631.211 259.281 631.374 259.34 631.544 259.362C631.714 259.384 631.886 259.369 632.05 259.317C633.761 258.773 635.364 257.938 636.482 256.687C636.652 256.499 636.746 256.254 636.746 256.001C636.746 255.747 636.652 255.502 636.482 255.314Z"
                stroke="#475467"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M629.445 287.425H636.548M629.445 291.059H636.548M625.019 296.318C625.124 297.248 625.54 298.115 626.201 298.777C626.862 299.439 627.727 299.858 628.657 299.966C630.071 300.124 631.52 300.259 633 300.259C634.48 300.259 635.931 300.124 637.344 299.966C638.273 299.858 639.139 299.439 639.799 298.777C640.46 298.115 640.877 297.248 640.982 296.318C641.132 294.914 641.259 293.471 641.259 292C641.259 290.529 641.132 289.086 640.982 287.68C640.877 286.751 640.46 285.884 639.799 285.222C639.139 284.559 638.273 284.14 637.344 284.033C635.93 283.877 634.48 283.741 633 283.741C631.52 283.741 630.069 283.876 628.657 284.034C627.727 284.142 626.862 284.561 626.201 285.223C625.54 285.885 625.124 286.752 625.019 287.682C624.868 289.085 624.741 290.528 624.741 292C624.741 293.472 624.868 294.914 625.019 296.318Z"
                stroke="#475467"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M629.62 319.78C632.579 318.877 631.848 323.82 630.47 328.515C629.137 333.06 627.048 337.729 625.227 335.934C623.02 333.759 627.685 331.925 632.613 330.431C637.14 329.058 642.128 328.308 641.231 331.145C640.426 333.686 636.936 330.894 633.379 327.553C629.908 324.295 626.828 320.634 629.62 319.78Z"
                stroke="#475467"
                stroke-width="1.5"
            />
            <path
                d="M505 562H44C39.5817 562 36 565.582 36 570C36 574.418 39.5817 578 44 578H505C509.418 578 513 574.418 513 570C513 565.582 509.418 562 505 562Z"
                fill="#8799B5"
                style="opacity: 0.15"
            />
            <path
                d="M36 594C36 589.582 39.5817 586 44 586H420C424.418 586 428 589.582 428 594C428 598.418 424.418 602 420 602H44C39.5817 602 36 598.418 36 594Z"
                fill="#8799B5"
                style="opacity: 0.15"
            />
            <path
                d="M651 256C651 251.582 654.582 248 659 248H810C814.418 248 818 251.582 818 256C818 260.418 814.418 264 810 264H659C654.582 264 651 260.418 651 256Z"
                fill="#8799B5"
                style="opacity: 0.15"
            />
            <path
                d="M651 292C651 287.582 654.582 284 659 284H780C784.418 284 788 287.582 788 292C788 296.418 784.418 300 780 300H659C654.582 300 651 296.418 651 292Z"
                fill="#8799B5"
                style="opacity: 0.15"
            />
            <path
                d="M651 328C651 323.582 654.582 320 659 320H839C843.418 320 847 323.582 847 328C847 332.418 843.418 336 839 336H659C654.582 336 651 332.418 651 328Z"
                fill="#8799B5"
                style="opacity: 0.15"
            />
            <g filter="url(#filter2_d_480_13732)">
                <path
                    d="M619 362.5H887C891.142 362.5 894.5 365.858 894.5 370V398C894.5 402.142 891.142 405.5 887 405.5H619C614.858 405.5 611.5 402.142 611.5 398V370C611.5 365.858 614.858 362.5 619 362.5Z"
                    fill="none"
                    stroke="var(--et-colors-border)"
                />
                <path
                    d="M628 381.5L633 386.5L638 381.5"
                    stroke="#98A2B3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <text
                    fill="var(--et-colors-text)"
                    xml:space="preserve"
                    style="white-space: pre"
                    font-family="Geist"
                    font-size="14"
                    font-weight="500"
                    letter-spacing="0em"
                >
                    <tspan x="651" y="388.9">Chapter 2</tspan>
                </text>
            </g>
            <g filter="url(#filter3_d_480_13732)">
                <path
                    d="M619 414.5H887C891.142 414.5 894.5 417.858 894.5 422V450C894.5 454.142 891.142 457.5 887 457.5H619C614.858 457.5 611.5 454.142 611.5 450V422C611.5 417.858 614.858 414.5 619 414.5Z"
                    fill="none"
                    stroke="var(--et-colors-border)"
                />
                <path
                    d="M628 433.5L633 438.5L638 433.5"
                    stroke="#98A2B3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <text
                    fill="var(--et-colors-text)"
                    xml:space="preserve"
                    style="white-space: pre"
                    font-family="Geist"
                    font-size="14"
                    font-weight="500"
                    letter-spacing="0em"
                >
                    <tspan x="651" y="440.9">Chapter 3</tspan>
                </text>
            </g>
        </g>
        <defs>
            <filter
                id="filter0_d_480_13732"
                x="46"
                y="449"
                width="184"
                height="48"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="1" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_480_13732"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_480_13732"
                    result="shape"
                />
            </filter>
            <filter
                id="filter1_d_480_13732"
                x="424"
                y="451"
                width="141"
                height="44"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="1" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_480_13732"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_480_13732"
                    result="shape"
                />
            </filter>
            <filter
                id="filter2_d_480_13732"
                x="609"
                y="361"
                width="288"
                height="48"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="1" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_480_13732"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_480_13732"
                    result="shape"
                />
            </filter>
            <filter
                id="filter3_d_480_13732"
                x="609"
                y="413"
                width="288"
                height="48"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="1" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_480_13732"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_480_13732"
                    result="shape"
                />
            </filter>
            <clipPath id="clip0_480_13732">
                <rect width="943" height="638" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
<script setup lang="ts"></script>
